import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import AppViewSportsbookImpl from './app-view-sportsbook.js';

const UIView = MojitoCore.Presentation.UIView;

/**
 * @class AppViewSportsbook
 * @memberof Mojito.Applications.Sports
 */

/**
 * AppViewSportsbook types.
 *
 * @property {node} [children] - The content to be displayed.
 *
 * @memberof Mojito.Applications.Sports.AppViewSportsbook
 */
const propTypes = {
    children: PropTypes.node,
};

export default UIView('AppViewSportsbook', AppViewSportsbookImpl, propTypes);
